const TYPOGRAPHY = {}

export default TYPOGRAPHY
